import { PHONE_MASK, INN_MASK, KPP_MASK, PHONE_PLACEHOLDER } from "@/consts";
import { useDataFormStore } from "@/stores/form";
import { limitInput } from "@/utils/handleChangeForm"
import { getArrayOfRules } from "@/utils/getDataForm"
import { getNameOrganization } from "@/utils/getDataForm";
import { ref } from "vue";
import { debounce  } from "@/utils/setDebounce";
import { ADDRESS } from "@/remotes";

const nameList = ref({});
const nameDropdown = ref();

const surnameList = ref({});
const surnameDropdown = ref();

const secondNameList = ref({});
const secondNameDropdown = ref();

export default {
  setup() {
    const dataForm = useDataFormStore();

    const options = [
      {
        value: "Стандарт",
        label: "Стандарт",
      },
      {
        value: "Цилиндры",
        label: "Цилиндры",
      },
      {
        value: "Шины",
        label: "Шины",
      },
    ];
    const optionsPersonType = [
      {
        value: 1,
        label: "Юр. лицо",
      },
      {
        value: 2,
        label: "ИП/БИН",
      },
      {
        value: 0,
        label: "Физ. лицо",
      },
    ];

    const optionsPersonTypeLegal = optionsPersonType.filter(o => o.value !== 0);

    const optionsWhoPays = [
      {
        value: "Отправитель",
        label: "Отправитель",
      },
      {
        value: "Получатель",
        label: "Получатель",
      },
      {
        value: "Третье лицо",
        label: "Третье лицо",
      },
    ];


    let checkThirdPerson = (whoPays) => whoPays === "Третье лицо";

    async function getNameList(value) {
      if (value.length > 1) {
        try {
          const { data } = await ADDRESS.post('4_1/rs/suggest/fio', { query: value, parts: ["NAME"] });
          nameList.value = data.suggestions;

          if(nameList.value.length < 1) {
            nameList.value[0] = {disabled: "true", class: "disable-notice", value: "Нет результатов"};
          } else {
            nameList.value.unshift({disabled: "true", class: "disable-notice", value: "Выберите имя"});
          }
        } catch (e) {
          console.log(e);
        }
      }

    }

    async function getSurNameList(value) {
      if (value.length > 1) {
        try {
          const { data } = await ADDRESS.post('4_1/rs/suggest/fio', { query: value, parts: ["SURNAME"] });
          surnameList.value = data.suggestions;

          if(surnameList.value.length < 1) {
            surnameList.value[0] = {disabled: "true", class: "disable-notice", value: "Нет результатов"};
          } else {
            surnameList.value.unshift({disabled: "true", class: "disable-notice", value: "Выберите фамилию"});
          }
        } catch (e) {
          console.log(e);
        }
      }

    }

    async function getSecondNameList(value) {
      if (value.length > 1) {
        try {
          const { data } = await ADDRESS.post('4_1/rs/suggest/fio', { query: value, parts: ["PATRONYMIC"] });
          secondNameList.value = data.suggestions;

          if(secondNameList.value.length < 1) {
            secondNameList.value[0] = {disabled: "true", class: "disable-notice", value: "Нет результатов"};
          } else {
            secondNameList.value.unshift({disabled: "true", class: "disable-notice", value: "Выберите отчество"});
          }
        } catch (e) {
          console.log(e);
        }
      }

    }

    let firstNametimeout = null;
    const getFirstNameSearch = (queryString, cb) => {
      
      // call callback function to return suggestions
      clearTimeout(firstNametimeout)
      firstNametimeout = setTimeout(() => {Array.isArray(cb(Array.isArray(nameList.value) ? nameList.value : []))}, 1000)
    }

    let surNametimeout = null;
    const getSurNameSearch = (queryString, cb) => {
      
      // call callback function to return suggestions
      clearTimeout(surNametimeout)
      surNametimeout = setTimeout(() => {cb(Array.isArray(surnameList.value) ? surnameList.value : [])}, 1000)
    }

    let secondNametimeout = null;
    const getSecondNameSearch = (queryString, cb) => {
      
      // call callback function to return suggestions
      clearTimeout(secondNametimeout)
      secondNametimeout = setTimeout(() => {cb(Array.isArray(secondNameList.value) ? secondNameList.value : [])}, 1000)
    }

    // Создаем задержку запроса в 1 секунду
    const getNameDebounce = debounce(getNameList, 1000)
    const getSurNameDebounce = debounce(getSurNameList, 1000)
    const getSecondNameDebounce = debounce(getSecondNameList, 1000)

    const convertToEnglish = (value) => value === "Отправитель" ? "Sender" : value === "Получатель" ? "Consignee" : value === "Третье лицо" ? "Customer" : ""

    const thirdPersonTypeChange = () => {

      // Каскадный сброс/обновление способа оплаты при смене типа третьего лица
      if (convertToEnglish(dataForm.payment.whoPaysForCargoTransportation) === 'Customer') {
        const typeOfPayment = dataForm.thirdPerson.typeThirdPerson ? 'Расчётный счёт юр.лица' : 'Наличные';
        dataForm.payment.typeOfPaymentForCargoTransportation = typeOfPayment;
        dataForm.payment.typeOfPaymentForCargoPickup = typeOfPayment;
        dataForm.payment.typeOfPaymentForCargoDelivery = typeOfPayment;
        dataForm.payment.typeOfPaymentForCargoExtraPacking = typeOfPayment;
      }

    }

    return {
      dataForm,
      options,
      optionsWhoPays,
      optionsPersonType,
      optionsPersonTypeLegal,
      PHONE_MASK,
      INN_MASK,
      KPP_MASK,
      PHONE_PLACEHOLDER,
      limitInput,
      getArrayOfRules,
      getNameOrganization,
      getFirstNameSearch,
      getSurNameSearch,
      getSecondNameSearch,
      thirdPersonTypeChange,
      nameDropdown,
      nameList,

      surnameDropdown,
      surnameList,

      secondNameDropdown,
      secondNameList,
      getName: function () {
        getNameDebounce(dataForm.thirdPerson.firstNameThirdPerson);
      },
      getSurName: function () {
        getSurNameDebounce(dataForm.thirdPerson.surnameThirdPerson);
      },
      getSecondName: function () {
        getSecondNameDebounce(dataForm.thirdPerson.secondNameThirdPerson);
      },

      clearThirdPerson: function () {
        if (checkThirdPerson(dataForm.thirdPerson.cargoTransportationCustomer)) {
          dataForm.thirdPerson.typeThirdPerson = 1;
        }
        if (
          !checkThirdPerson(dataForm.thirdPerson.cargoTransportationCustomer)
        ) {
          dataForm.payment.whoPaysForCargoPickup = !checkThirdPerson(
            dataForm.payment.whoPaysForCargoPickup
          )
            ? dataForm.payment.whoPaysForCargoPickup
            : "";
          dataForm.payment.whoPaysForCargoTransportation = !checkThirdPerson(
            dataForm.payment.whoPaysForCargoTransportation
          )
            ? dataForm.payment.whoPaysForCargoTransportation
            : "";
          dataForm.payment.whoPaysForCargoDelivery = !checkThirdPerson(
            dataForm.payment.whoPaysForCargoDelivery
          )
            ? dataForm.payment.whoPaysForCargoDelivery
            : "";
          dataForm.payment.whoPaysForCargoExtraPacking = !checkThirdPerson(
            dataForm.payment.whoPaysForCargoExtraPacking
          )
            ? dataForm.payment.whoPaysForCargoExtraPacking
            : "";
        }
      },
    };
  },
};
